import { Card } from "react-bootstrap";
import style from "./metricasSelectCard.module.css";
import { Select } from "components/Select/Select";

interface Props {
  title: string;
  opcionesSelect: { id: string | number; nombre: string }[];
  arrDetalle: { cantidad: string | number; title: string }[]; // Permitir ambos tipos
  values: { [key: string]: string };
  id: string;
  handleChangeSelect: (e: any) => void;
}

export const MetricaSelectCard = ({
  title,
  opcionesSelect,
  arrDetalle,
  values,
  id,
  handleChangeSelect,
}: Props) => {
  // Transformamos las opciones para que coincidan con optionsFormatConfig
  const formattedOptions = opcionesSelect.map((opcion) => ({
    id: opcion.id,
    name: opcion.nombre, // Renombramos "nombre" a "name"
  }));

  return (
    <Card className={`metrica-card`}>
      <p className={style["metrica-title"]}>{title}</p>
      <hr className="my-2"></hr>
      <div className="mb-3">
        <Select
          id={id}
          values={values}
          onChange={handleChangeSelect} // Actualizar el valor seleccionado
          options={formattedOptions ?? []} // Usar las opciones transformadas
          optionsFormatConfig={{ value: "id", label: "name" }}
          isLoading={!opcionesSelect.length} // Muestra un indicador de carga
          placeholder="Seleccionar"
        />
      </div>
      <div className="d-flex flex-column gap-3">
        {arrDetalle.map((ctOp) => (
          <div key={ctOp.title} className="d-flex justify-content-between">
            <p className={style["metrica-detalle-title"]}>{ctOp.title}</p>
            <p className={style["metrica-detalle-numero"]}>{ctOp.cantidad}</p>
          </div>
        ))}
      </div>
    </Card>
  );
};
